export default {
  modal: 400,
  navbar: 300,
  intercom: 200,
  select: 100
};
